import React from 'react';

interface SeeMoreButtonProps {
  onClick: () => void;
  className?: string;
  buttonClassName?: string;
  text?: string;
}

export const SeeMoreButton: React.FC<SeeMoreButtonProps> = ({
  onClick,
  className = '',
  buttonClassName = 'bg-see-more hover:bg-see-more-hover text-primary',
  text = 'See more',
}) => {
  return (
    <div className={`mt-6 flex justify-center ${className}`}>
      <button
        onClick={onClick}
        className={`font-albert-sans inline-flex h-10 min-w-[344px] max-w-[412px] items-center justify-center gap-1.5 rounded-full px-6 py-2.5 text-base font-medium leading-5 transition-colors ${buttonClassName}`}
      >
        {text}
      </button>
    </div>
  );
};
